import { inject, Injectable } from '@angular/core'

import { LanguageCode } from '@ti/contracts'
import { ApiService } from '@ti/core/api'
import { LanguageService } from '@ti/core/ui-kit/i18n'

import { McpAuthContext } from '../../../mcp/bootstrap/mcp-auth-context'

@Injectable()
export class TiAdminLanguageService extends LanguageService {
  protected readonly api = inject(ApiService)
  private readonly mcpContext = inject(McpAuthContext)

  protected override async saveCurrentUserLanguage(language: LanguageCode) {
    if ((await this.authSession.isLoggedIn()) && !this.mcpContext.isAuthFlow) {
      await this.api.tsp.user.setLanguage(language)
    }
  }
}
